import { render, staticRenderFns } from "./compradorShow.vue?vue&type=template&id=6b7f7c14"
import script from "./compradorShow.vue?vue&type=script&lang=js"
export * from "./compradorShow.vue?vue&type=script&lang=js"
import style0 from "./compradorShow.vue?vue&type=style&index=0&id=6b7f7c14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports